"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEventVersion = exports.BuilderConfigStatuses = exports.SweepstakesRulesTypes = exports.PostShowEmailCTATypes = exports.PostShowEmailTypes = exports.PolicyEntities = exports.PostRegistationOptions = exports.VoteTypeOptions = exports.CheckInVoteOptions = exports.Languages = exports.getSocialLinks = exports.StreamingServiceNames = exports.generatePostRegText = exports.generatePreRegText = void 0;
const event_1 = require("../event");
const utils_1 = require("../utils");
const postregistration_1 = require("./postregistration");
const preregistration_1 = require("./preregistration");
const privacy_1 = require("./privacy");
const colors_1 = require("./colors");
const generateBuilderConfig_1 = require("./generateBuilderConfig");
var preregistration_2 = require("./preregistration");
Object.defineProperty(exports, "generatePreRegText", { enumerable: true, get: function () { return preregistration_2.generatePreRegText; } });
var postregistration_2 = require("./postregistration");
Object.defineProperty(exports, "generatePostRegText", { enumerable: true, get: function () { return postregistration_2.generatePostRegText; } });
__exportStar(require("./generateCustomFields"), exports);
__exportStar(require("./colors"), exports);
__exportStar(require("./generateBuilderConfig"), exports);
__exportStar(require("./privacy"), exports);
// From spotify
/**
 * - album
 * - single
 * - appears_on (ignore??)
 * - compilation (ignore??)
 */
exports.StreamingServiceNames = [
    { path: "appleMusic", name: "Apple Music" },
    { path: "amazon", name: "Amazon Music" },
    { path: "pandora", name: "Pandora" },
    { path: "spotify", name: "Spotify" },
    { path: "youtubeMusic", name: "YouTube Music" },
    { path: "deezer", name: "Deezer" },
    { path: "iHeartRadio", name: "iHeartRadio" },
    { path: "tidal", name: "Tidal" },
];
/**
 * Extracts social links from bulder config doc.
 */
const getSocialLinks = (config) => {
    const getSocialKey = (key) => {
        var _a;
        const { name } = ((_a = key.match(/socialLink(?<name>.*)/)) === null || _a === void 0 ? void 0 : _a.groups) || {};
        if (name) {
            if (event_1.SocialLinkNames.includes(name.toLowerCase())) {
                return name.toLowerCase();
            }
        }
    };
    return Object.fromEntries(Object.entries(config.fields || {})
        .map(([key, value]) => {
        const k = getSocialKey(key);
        value.content;
        if (k && typeof value.content === "string") {
            return [k, value.content];
        }
        return undefined;
    })
        .filter(utils_1.filterUndefined));
};
exports.getSocialLinks = getSocialLinks;
exports.Languages = {
    es: "Spanish",
    fr: "French",
    de: "German",
};
exports.CheckInVoteOptions = ["checkin", "vote"];
exports.VoteTypeOptions = ["song", "vote"];
exports.PostRegistationOptions = ["thank", "promo", "link"];
exports.PolicyEntities = [
    { path: "artist", name: "Artist" },
    { path: "management", name: "Management" },
    { path: "recordLabel", name: "Record Label" },
    { path: "marketing", name: "Marketing" },
    { path: "other", name: "Other" },
];
exports.PostShowEmailTypes = [
    "disabled",
    "default",
    "custom",
    "html",
];
exports.PostShowEmailCTATypes = ["survey", "custom", "disabled"];
exports.SweepstakesRulesTypes = [
    "default",
    "link",
    "html",
    "custom",
];
exports.BuilderConfigStatuses = [
    "created",
    "draft",
    "publish_requested",
    "published",
];
/**
 * Check to see if the provided object is a Luxon DateTime instance.
 */
const isDateTime = (maybeDateTime) => {
    const d = Object.getOwnPropertyDescriptor(maybeDateTime, "isLuxonDateTime");
    return (d === null || d === void 0 ? void 0 : d.value) === true;
};
/**
 * Generate a SETLive fan config document.
 */
const generateEventVersion = (config, { language = "en", demoConfig, props, Timestamp, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107;
    const postRegText = (0, postregistration_1.generatePostRegText)(config);
    const { preRegText } = (0, preregistration_1.generatePreRegText)(config);
    //
    // TODO: Make translatable
    //
    const { sms, terms, separateTerms } = (0, privacy_1.generatePrivacyText)(config, language);
    const getTimestamp = (dateThingy) => {
        if (isDateTime(dateThingy)) {
            return Timestamp.fromDate(dateThingy.toJSDate());
        }
        return dateThingy;
    };
    const disableDefaultCopy = !!(props === null || props === void 0 ? void 0 : props.override.disableDefaultCopy);
    const image = ((_b = (_a = config === null || config === void 0 ? void 0 : config.fields) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.content) ||
        ((_d = (_c = config === null || config === void 0 ? void 0 : config.images) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.src) ||
        (demoConfig === null || demoConfig === void 0 ? void 0 : demoConfig.header.image);
    const { imageColors, imageIndex } = (0, colors_1.getColorConfig)(config);
    const date = ((_f = (_e = config.fields) === null || _e === void 0 ? void 0 : _e.startTime) === null || _f === void 0 ? void 0 : _f.content)
        ? getTimestamp(config.fields.startTime.content)
        : demoConfig === null || demoConfig === void 0 ? void 0 : demoConfig.header.date;
    const type = ((_g = props === null || props === void 0 ? void 0 : props.override) === null || _g === void 0 ? void 0 : _g.type) !== undefined
        ? (_h = props === null || props === void 0 ? void 0 : props.override) === null || _h === void 0 ? void 0 : _h.type
        : ((_k = (_j = config.fields) === null || _j === void 0 ? void 0 : _j.type) === null || _k === void 0 ? void 0 : _k.content) || 0;
    const colors = ((_l = props === null || props === void 0 ? void 0 : props.override) === null || _l === void 0 ? void 0 : _l.colors) ||
        ((_q = (_p = (_o = (_m = config.fields) === null || _m === void 0 ? void 0 : _m.colors) === null || _o === void 0 ? void 0 : _o.content) === null || _p === void 0 ? void 0 : _p[imageIndex]) === null || _q === void 0 ? void 0 : _q[type]) ||
        ((_r = imageColors === null || imageColors === void 0 ? void 0 : imageColors[type]) === null || _r === void 0 ? void 0 : _r[0]);
    if (!config.fields ||
        ((_t = (_s = config.fields) === null || _s === void 0 ? void 0 : _s.type) === null || _t === void 0 ? void 0 : _t.content) === undefined ||
        !image ||
        !date ||
        !colors) {
        throw new Error("TODO: Handle this");
    }
    if (disableDefaultCopy) {
        preRegText.headline = "";
        preRegText.subtitle = "";
        preRegText.body = "";
        postRegText.headline = "";
        postRegText.body = "";
    }
    const optionalSms = ((_v = (_u = config.customRegister) === null || _u === void 0 ? void 0 : _u[language]) === null || _v === void 0 ? void 0 : _v.optionalSms) ||
        !!((_w = config.fields.makeTextMessageOptInOptional) === null || _w === void 0 ? void 0 : _w.content);
    const optionalPhone = ((_y = (_x = config.customRegister) === null || _x === void 0 ? void 0 : _x[language]) === null || _y === void 0 ? void 0 : _y.optionalPhone) ||
        !!((_z = config.fields.makePhoneNumberFieldOptional) === null || _z === void 0 ? void 0 : _z.content);
    const register = {
        ...demoConfig === null || demoConfig === void 0 ? void 0 : demoConfig.register,
        ...(_0 = config.customRegister) === null || _0 === void 0 ? void 0 : _0[language],
        title: (_2 = (_1 = config.fields.registerTitle) === null || _1 === void 0 ? void 0 : _1.content) === null || _2 === void 0 ? void 0 : _2[language],
        subtitle: (_4 = (_3 = config.fields.registerSubtitle) === null || _3 === void 0 ? void 0 : _3.content) === null || _4 === void 0 ? void 0 : _4[language],
        ctalabel: ((_6 = (_5 = config.fields.registerCtaLabel) === null || _5 === void 0 ? void 0 : _5.content) === null || _6 === void 0 ? void 0 : _6[language]) ||
            (((_8 = (_7 = config === null || config === void 0 ? void 0 : config.fields) === null || _7 === void 0 ? void 0 : _7.checkInVote) === null || _8 === void 0 ? void 0 : _8.content) === "vote" ? "Vote" : "Check In"),
        sms,
        terms,
        ...(!((_9 = config.fields.useCustomTermsAndPrivacyPolicy) === null || _9 === void 0 ? void 0 : _9.content)
            ? {
                ...(!!(separateTerms === null || separateTerms === void 0 ? void 0 : separateTerms.length) && {
                    customTerms: separateTerms[0],
                }),
                ...((separateTerms === null || separateTerms === void 0 ? void 0 : separateTerms.length) &&
                    separateTerms.length > 1 && {
                    customAgreement: separateTerms[1],
                }),
            }
            : {
                terms: (_11 = (_10 = config.fields.customTermsAndPrivacyPolicy) === null || _10 === void 0 ? void 0 : _10.content) === null || _11 === void 0 ? void 0 : _11[language],
                customTerms: (_13 = (_12 = config.fields.separateLineTermsAndPrivacyPolicy) === null || _12 === void 0 ? void 0 : _12.content) === null || _13 === void 0 ? void 0 : _13[language],
            }),
        ...(((_14 = config.fields.useCustomSMSOptIn) === null || _14 === void 0 ? void 0 : _14.content) && {
            sms: (_16 = (_15 = config.fields.customSMSOptIn) === null || _15 === void 0 ? void 0 : _15.content) === null || _16 === void 0 ? void 0 : _16[language],
        }),
        hasSweepstakes: (_17 = config.fields.sweepstakes) === null || _17 === void 0 ? void 0 : _17.content,
        optionalSms,
        optionalPhone,
    };
    if ((_18 = config.fields.sweepstakes) === null || _18 === void 0 ? void 0 : _18.content) {
        if (((_19 = config.fields.sweepstakesRulesType) === null || _19 === void 0 ? void 0 : _19.content) === "html") {
            register.customSweepstakesRules =
                (_21 = (_20 = config.fields.sweepstakesRulesHtml) === null || _20 === void 0 ? void 0 : _20.content) === null || _21 === void 0 ? void 0 : _21[language];
        }
        if (((_22 = config.fields.sweepstakesRulesType) === null || _22 === void 0 ? void 0 : _22.content) === "link") {
            register.customSweepstakesRules =
                (process.env.REACT_APP_RULES_URL || "https://rules.set.live") +
                    `/${(_24 = (_23 = config.fields.sweepstakesRulesLink) === null || _23 === void 0 ? void 0 : _23.content) === null || _24 === void 0 ? void 0 : _24[language]}`;
        }
        if (((_25 = config.fields.sweepstakesRulesType) === null || _25 === void 0 ? void 0 : _25.content) === "custom") {
            register.customSweepstakesRules =
                (_27 = (_26 = config.fields.sweepstakesRulesCustomUrl) === null || _26 === void 0 ? void 0 : _26.content) === null || _27 === void 0 ? void 0 : _27[language];
        }
    }
    const fanConfig = {
        ...demoConfig,
        type,
        header: {
            ...demoConfig === null || demoConfig === void 0 ? void 0 : demoConfig.header,
            artistName: ((_29 = (_28 = config === null || config === void 0 ? void 0 : config.fields) === null || _28 === void 0 ? void 0 : _28.displayedName) === null || _29 === void 0 ? void 0 : _29.content) || config.artistName || "",
            date,
            image,
            venue: (_31 = (_30 = config.fields.concert) === null || _30 === void 0 ? void 0 : _30.content) === null || _31 === void 0 ? void 0 : _31.venue,
        },
        cards: [
            {
                cta: "register",
                visible: {
                    states: [event_1.UserEventStates.draft],
                },
                headline: ((_33 = (_32 = config.fields.preRegistrationHeadline) === null || _32 === void 0 ? void 0 : _32.content) === null || _33 === void 0 ? void 0 : _33[language]) ||
                    preRegText.headline,
                ...(((_34 = config.fields.checkInVote) === null || _34 === void 0 ? void 0 : _34.content) === "vote"
                    ? {
                        // Voting
                        tab: "Vote",
                        subtitle: ((_36 = (_35 = config.fields.preRegistrationSubtitle) === null || _35 === void 0 ? void 0 : _35.content) === null || _36 === void 0 ? void 0 : _36[language]) ||
                            preRegText.subtitle,
                        ...(((_37 = config.fields.voteType) === null || _37 === void 0 ? void 0 : _37.content) === "song"
                            ? {
                                // Songs
                                songs: (_40 = (_39 = (_38 = config.fields.songOptions) === null || _38 === void 0 ? void 0 : _38.content) === null || _39 === void 0 ? void 0 : _39.filter((song) => !!song.name)) === null || _40 === void 0 ? void 0 : _40.map((s) => ({
                                    id: s.name + s.album || "",
                                    title: s.name || "",
                                    album: s.album || "",
                                })),
                            }
                            : {
                                // Something else
                                songs: (_43 = (_42 = (_41 = config.fields.voteOptions) === null || _41 === void 0 ? void 0 : _41.content) === null || _42 === void 0 ? void 0 : _42.filter((option) => !!(option === null || option === void 0 ? void 0 : option[language]))) === null || _43 === void 0 ? void 0 : _43.map((s) => ({
                                    id: (s === null || s === void 0 ? void 0 : s[language]) || "",
                                    title: (s === null || s === void 0 ? void 0 : s[language]) || "",
                                })),
                            }),
                    }
                    : {
                        // Check In
                        tab: "Check In",
                        ctalabel: "Check In",
                        body: ((_45 = (_44 = config.fields.preRegistrationBody) === null || _44 === void 0 ? void 0 : _44.content) === null || _45 === void 0 ? void 0 : _45[language]) ||
                            preRegText.body,
                        ...(((_47 = (_46 = config.fields.preRegistrationButtonLabel) === null || _46 === void 0 ? void 0 : _46.content) === null || _47 === void 0 ? void 0 : _47[language]) && {
                            ctalabel: (_49 = (_48 = config.fields.preRegistrationButtonLabel) === null || _48 === void 0 ? void 0 : _48.content) === null || _49 === void 0 ? void 0 : _49[language],
                        }),
                    }),
            },
        ],
        colors: colors,
        register,
        social: {
            title: `${(_51 = (_50 = config.fields.postRegistrationButtonLabel) === null || _50 === void 0 ? void 0 : _50.content) === null || _51 === void 0 ? void 0 : _51[language]} ${(_53 = (_52 = config.fields.postRegistrationAlbum) === null || _52 === void 0 ? void 0 : _52.content) === null || _53 === void 0 ? void 0 : _53.name} on your favorite streaming service.`,
            // subtitle: "available on:", this field not in use
            spotify: (_55 = (_54 = config.fields.postRegistrationAlbum) === null || _54 === void 0 ? void 0 : _54.content) === null || _55 === void 0 ? void 0 : _55.spotify,
            apple: (_57 = (_56 = config.fields.postRegistrationAlbum) === null || _56 === void 0 ? void 0 : _56.content) === null || _57 === void 0 ? void 0 : _57.appleMusic,
            amazon: (_59 = (_58 = config.fields.postRegistrationAlbum) === null || _58 === void 0 ? void 0 : _58.content) === null || _59 === void 0 ? void 0 : _59.amazon,
            deezer: (_61 = (_60 = config.fields.postRegistrationAlbum) === null || _60 === void 0 ? void 0 : _60.content) === null || _61 === void 0 ? void 0 : _61.deezer,
            youtube: (_63 = (_62 = config.fields.postRegistrationAlbum) === null || _62 === void 0 ? void 0 : _62.content) === null || _63 === void 0 ? void 0 : _63.youtubeMusic,
            pandora: (_65 = (_64 = config.fields.postRegistrationAlbum) === null || _64 === void 0 ? void 0 : _64.content) === null || _65 === void 0 ? void 0 : _65.pandora,
            tidal: (_67 = (_66 = config.fields.postRegistrationAlbum) === null || _66 === void 0 ? void 0 : _66.content) === null || _67 === void 0 ? void 0 : _67.tidal,
        },
        socialLinks: {
            facebook: (_68 = config.fields.socialLinkFacebook) === null || _68 === void 0 ? void 0 : _68.content,
            instagram: (_69 = config.fields.socialLinkInstagram) === null || _69 === void 0 ? void 0 : _69.content,
            tiktok: (_70 = config.fields.socialLinkTiktok) === null || _70 === void 0 ? void 0 : _70.content,
            spotify: (_71 = config.fields.socialLinkSpotify) === null || _71 === void 0 ? void 0 : _71.content,
            youtube: (_72 = config.fields.socialLinkYoutube) === null || _72 === void 0 ? void 0 : _72.content,
            twitter: (_73 = config.fields.socialLinkTwitter) === null || _73 === void 0 ? void 0 : _73.content,
            shazam: (_74 = config.fields.socialLinkShazam) === null || _74 === void 0 ? void 0 : _74.content,
        },
        ...(((_76 = (_75 = config.fields.footer) === null || _75 === void 0 ? void 0 : _75.content) === null || _76 === void 0 ? void 0 : _76.en) && {
            footer: (_78 = (_77 = config.fields.footer) === null || _77 === void 0 ? void 0 : _77.content) === null || _78 === void 0 ? void 0 : _78.en,
        }),
    };
    if (fanConfig.cards && ((_79 = config.fields.useCustomMainTabName) === null || _79 === void 0 ? void 0 : _79.content) === true) {
        fanConfig.cards[0].tab =
            (_81 = (_80 = config.fields.customMainTabName) === null || _80 === void 0 ? void 0 : _80.content) === null || _81 === void 0 ? void 0 : _81[language];
    }
    // Post registration view
    if (fanConfig.cards) {
        fanConfig.cards.push({
            tab: fanConfig.cards[0].tab,
            ...postRegText,
            headline: ((_83 = (_82 = config.fields.postRegistrationHeadline) === null || _82 === void 0 ? void 0 : _82.content) === null || _83 === void 0 ? void 0 : _83[language]) ||
                postRegText.headline,
            body: ((_85 = (_84 = config.fields.postRegistrationBody) === null || _84 === void 0 ? void 0 : _84.content) === null || _85 === void 0 ? void 0 : _85[language]) ||
                postRegText.body,
            // Promote a Release
            ...(((_86 = config.fields.postRegistration) === null || _86 === void 0 ? void 0 : _86.content) === "promo" && {
                image: (_89 = (_88 = (_87 = config === null || config === void 0 ? void 0 : config.fields) === null || _87 === void 0 ? void 0 : _87.postRegistrationAlbum) === null || _88 === void 0 ? void 0 : _88.content) === null || _89 === void 0 ? void 0 : _89.image,
                ctalabel: ((_91 = (_90 = config.fields.postRegistrationButtonLabel) === null || _90 === void 0 ? void 0 : _90.content) === null || _91 === void 0 ? void 0 : _91[language]) ||
                    postRegText.ctalabel,
                cta: "social",
            }),
            // Custom Link
            ...(((_92 = config.fields.postRegistration) === null || _92 === void 0 ? void 0 : _92.content) === "link" && {
                cta: ((_93 = config.fields.postRegistrationLinkUrl) === null || _93 === void 0 ? void 0 : _93.content) || postRegText.cta,
                ctalabel: ((_95 = (_94 = config.fields.postRegistrationLinkLabel) === null || _94 === void 0 ? void 0 : _94.content) === null || _95 === void 0 ? void 0 : _95[language]) ||
                    postRegText.ctalabel,
            }),
            visible: {
                states: [event_1.UserEventStates.draft],
                hide: true,
            },
        });
    }
    // Merch View
    const merchTabName = !((_96 = config.fields.useCustomMerchTabName) === null || _96 === void 0 ? void 0 : _96.content)
        ? "Merch"
        : (_98 = (_97 = config.fields.customMerchTabName) === null || _97 === void 0 ? void 0 : _97.content) === null || _98 === void 0 ? void 0 : _98[language];
    if (!((_99 = config.fields.hideMerchandise) === null || _99 === void 0 ? void 0 : _99.content) &&
        !!((_101 = (_100 = config.fields.merchandise) === null || _100 === void 0 ? void 0 : _100.content) === null || _101 === void 0 ? void 0 : _101.length) &&
        fanConfig.cards) {
        fanConfig.cards.push({
            tab: merchTabName,
            ...(fanConfig.type === 0 && {
                headline: merchTabName,
                icon: "shirt",
            }),
            merch: (_103 = (_102 = config.fields.merchandise) === null || _102 === void 0 ? void 0 : _102.content) === null || _103 === void 0 ? void 0 : _103.reduce((acc, m) => {
                if (m.isSelected) {
                    acc.push({
                        ...m,
                        photo: m.img,
                        name: m.text,
                    });
                }
                return acc;
            }, []),
        });
    }
    // If swiper, add icons to pre & post registration cards
    if (fanConfig.type === 0 && fanConfig.cards) {
        fanConfig.cards[0].icon =
            ((_104 = config.fields.checkInVote) === null || _104 === void 0 ? void 0 : _104.content) === "vote" ? "checklist" : "user";
        fanConfig.cards[1].icon = "checkmark";
    }
    const country = (0, generateBuilderConfig_1.getAddressComponent)("country", (_107 = (_106 = (_105 = config.fields.concert) === null || _105 === void 0 ? void 0 : _105.content) === null || _106 === void 0 ? void 0 : _106.geocode) === null || _107 === void 0 ? void 0 : _107.address_components);
    if (!!country) {
        fanConfig.meta = {
            country: country,
        };
    }
    return (0, utils_1.removeUndefined)(fanConfig);
};
exports.generateEventVersion = generateEventVersion;
//# sourceMappingURL=index.js.map